import { motion } from 'framer-motion';
import { ReactNode } from 'react';

interface BlurFadeProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  yOffset?: number;
}

function BlurFade({ children, className, delay = 0, yOffset = 6 }: BlurFadeProps) {
  return (
    <motion.div
      initial={{ y: -yOffset, opacity: 0, filter: 'blur(6px)' }}
      animate={{ y: 0, opacity: 1, filter: 'blur(0px)' }}
      transition={{ delay: 0.04 + delay, duration: 0.4, ease: 'easeOut' }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export default BlurFade;
